import React, { memo, useEffect, useRef } from "react";
import PropTypes from "prop-types";

const SymbolsOnlyInput = (props) => {
  const {
    className,
    placeholder,
    value,
    style,
    hidden,
    name,
    required,
    appendClassName,
    disabled,
    readOnly,
    id,
    autofocus,
    changeHandler,
    onKeyPressHandler,
    onKeyDownHandler,
  } = props;

  const inputRef = useRef(null);

  useEffect(() => {
    if (autofocus && inputRef.current) {
      const input = inputRef.current;
      input.focus();

      const length = input.value.length;
      input.setSelectionRange(length, length);
    }
  }, [autofocus]);

  const onChangeHandler = (e) => {
    let val = e.target.value;

    // ✅ Allow only symbols and spaces
    val = val.replace(/[a-zA-Z0-9]/g, ""); 

    changeHandler(val, { e });
  };

  return (
    <input
      ref={inputRef}
      type="text"
      id={id}
      className={`${className} ${appendClassName}`}
      name={name}
      placeholder={placeholder}
      value={value}
      style={{ ...style }}
      onKeyUp={onKeyPressHandler}
      onKeyDown={onKeyDownHandler}
      required={required}
      hidden={hidden}
      disabled={disabled}
      readOnly={readOnly}
      onChange={(e) => onChangeHandler(e)}
    />
  );
};

SymbolsOnlyInput.defaultProps = {
  className: "form-control form-control-solid",
  placeholder: "",
  appendClassName: "",
  value: "",
  id: "",
  style: {},
  onKeyPressHandler: () => {},
  onKeyDownHandler: () => {},
  readOnly: false,
  disabled: false,
  required: false,
  hidden: false,
};

SymbolsOnlyInput.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.string,
  style: PropTypes.object,
  changeHandler: PropTypes.func.isRequired,
};

export default memo(SymbolsOnlyInput);
